import { Model } from '@model/utils/Model';

export const Country = Model('Country', { endpoint: 'countries' })`
    id:Int;
    name:String;
    code:String;
    calling_code:String;
`;
